var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10a9 9 0 1118 0 9 9 0 01-18 0z",
    fill: "#5FC375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.063 10l2.624 2.625 5.25-5.25",
    stroke: "#fff",
    strokeWidth: 1.25
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgOS45OTk5NUMxIDUuMDI5NDEgNS4wMjk0MSAxIDkuOTk5OTUgMUMxNC45NzA1IDEgMTguOTk5OSA1LjAyOTQxIDE4Ljk5OTkgOS45OTk5NUMxOC45OTk5IDE0Ljk3MDUgMTQuOTcwNSAxOC45OTk5IDkuOTk5OTUgMTguOTk5OUM1LjAyOTQxIDE4Ljk5OTkgMSAxNC45NzA1IDEgOS45OTk5NVoiIGZpbGw9IiM1RkMzNzUiLz4KPHBhdGggZD0iTTYuMDYyNSA5Ljk5OTk5TDguNjg3NDkgMTIuNjI1TDEzLjkzNzUgNy4zNzUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS4yNSIvPgo8L3N2Zz4K";
export { SvgSuccess as ReactComponent };